var ChatRoutes;
(function (ChatRoutes) {
    ChatRoutes["Chat"] = "/chat";
    ChatRoutes["CustomerDetails"] = "/customer-details";
    ChatRoutes["FindingAgent"] = "/finding-agent";
    ChatRoutes["Survey"] = "/survey";
})(ChatRoutes || (ChatRoutes = {}));
export default ChatRoutes;
//# sourceMappingURL=chat-routes.js.map